// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    HTML_SITEMAP_INDEX_LOADING() {
      return {
        isLoading: true,
        htmlSitemapIndex: action.htmlSitemapIndex
      };
    },
    HTML_SITEMAP_INDEX_LOADED() {
      return {
        isLoading: false,
        data: action.htmlSitemapIndex
      };
    },
    HTML_SITEMAP_INDEX_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.htmlSitemapIndex.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
